import { useEffect } from 'react';

const usePrefillHiddenFields = (fieldIds: string[]) => {
  useEffect(() => {
    fieldIds.forEach((id) => {
      const el = document.getElementById(id) as HTMLInputElement | null;
      if (el && typeof window !== 'undefined') {
        el.value = localStorage.getItem(id) || '';
      }
    });
  }, [fieldIds]);
};

export default usePrefillHiddenFields;
